class Row {
	constructor(nr, complex) {
		this.nr = nr;
		this.complex = complex;
	}

	createTR(complex_template) {
		const clone = complex_template.content.cloneNode(true);
		const tr = clone.querySelector("tr");
		const td = tr.querySelectorAll("td");

		td[0].textContent = this.complex.id.substring(7);
		td[1].textContent = `(${this.geneNames})`;
		td[2].textContent = this.complex.iptm.toFixed(2);
		td[3].textContent = (this.complex.meanDepMapCorrelation ? this.complex.meanDepMapCorrelation.toFixed(2) : "N/A");
		td[4].textContent = this.complex.AB_score.toFixed(2);
		if (this.complex.hasLLMReport)
			td[5].querySelector("i").classList.add("bi", "bi-check");

		return clone;
	}

	setTR(tr) {
		this.tr = tr;
		this.tr.addEventListener("click", (evt) => {
			evt.preventDefault();

			window.location.href = `complex.html?id=${this.complex.id}`;
		})
	}

	get geneNames() {
		return this.complex.genes.map(gene => gene.gene_names[0]).join(", ");
	}

	processQuery(query) {
		let td = this.tr.querySelectorAll("td");

		if (typeof query != "string" || query.length == 0) {
			this.tr.classList.remove("nomatch");
		}
		else {
			let match = this.complex.genes.flatMap(gene => [...gene.gene_names, ...gene.accession_codes])
					.filter(gene => gene.indexOf(query) >= 0)
					.length > 0;
	
			if (match)
				td[1].innerHTML = `(${this.geneNames.replaceAll(query, `<span class="match">${query}</span>`)})`;
			else
				td[1].textContent = `(${this.geneNames})`;
	
			this.tr.classList.toggle("nomatch", match == false);
		}
	}
}

const rows = [];

async function fillTable() {
	const r = await fetch("data.json");
	const data = await r.json();

	const table = document.querySelector("table");
	const tbody = table.querySelector("tbody");

	data.forEach((gene, ix) => {
		rows.push(new Row(ix + 1, gene));
	});

	const complex_template = document.querySelector("#complex-template");
	tbody.replaceChildren(...rows.map(row => row.createTR(complex_template)));

	const tableRows = tbody.querySelectorAll("tr");
	for (let i = 0; i < tableRows.length; ++i) {
		rows[i].setTR(tableRows[i]);
	}
}

window.addEventListener("load", () => {
	fillTable();

	const searchPanel = document.querySelector("#search-panel");
	searchPanel.addEventListener("input", (e) => {
		const q = searchPanel.value;
		rows.forEach(row => row.processQuery(q.toUpperCase()));
	})
})